import { TriggerTypes } from "@enums/trigger-types";
import { SimpleDeployedPolicyComponentCondition } from "@idw-types/data/reference-data/generic";
import { FormattedPolicyComponent, PolicyComponent } from "@idw-types/data/reference-data/generic/policy-component";

export const getPolicyComponent = (formattedPolicyComponent: FormattedPolicyComponent): PolicyComponent => {
    const conditions = formattedPolicyComponent.conditions.map(condition => {
        //@ts-ignore
        return { ...condition, uuid: undefined, triggerType: undefined };
    });

    return {
        ...formattedPolicyComponent,
        conditions
    }
}

export const getTriggerType = (condition: SimpleDeployedPolicyComponentCondition): TriggerTypes => {
    if (condition.assertionID !== null && condition.serviceOfferingID !== null) {
        return TriggerTypes.ASSERTION;
    } else if (condition.componentID !== null) {
        return TriggerTypes.COMPONENT;
    } else if (condition.attributeFieldID !== null && condition.serviceOfferingID !== null) {
        return TriggerTypes.ACQUIRED_DATA;
    } else if (condition.attributeFieldID) {
        return TriggerTypes.USER_INPUT;
    }

    return null;
}